import React from 'react';
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
import {Pie} from 'react-chartjs-2';
import DashboardCardWrapper from '../common/DashboardCardWrapper';
import {pageRoutes} from '../../routes';

ChartJS.register(ArcElement, Tooltip, Legend);

const JobStatistics = ({statistics}) => {
  const allChartData = [
    {
      label: 'Total posted jobs',
      value: statistics?.totalJob || 0,
      hex: '#6D38FC',
      id: 1,
    },
    {
      label: 'Total closed jobs',
      value: statistics?.closedJob || 0,
      hex: '#BAF639',
      id: 2,
    },
    {
      label: 'Total open jobs',
      value: statistics?.openJob || 0,
      hex: '#27CF4C',
      id: 3,
    },
  ];

  const title = (tooltipItems) => {
    let lable = '';
    tooltipItems.forEach(function (tooltipItem) {
      lable = tooltipItem?.dataset?.lables[tooltipItem.dataIndex];
    });
    return lable;
  };

  const chartData = {
    datasets: [
      {
        lables: ['Total posted jobs', 'Total closed jobs', 'Total open jobs'],
        data: [
          statistics?.totalJob || 0,
          statistics?.closedJob || 0,
          statistics?.openJob || 0,
        ],
        backgroundColor: [
          'rgba(109, 56, 252, 1)',
          'rgba(186, 246, 57, 1)',
          'rgba(39, 207, 76, 1)',
        ],
        borderColor: [
          'rgba(255, 255, 255, 1)',
          'rgba(255, 255, 255, 1)',
          'rgba(255, 255, 255, 1)',
        ],
        borderWidth: 2,
      },
    ],
  };

  const option = {
    plugins: {
      tooltip: {
        callbacks: {
          title: title,
        },
        backgroundColor: '#fff',
        bodyColor: '#000',
        padding: 10,
        titleColor: '#808080',
        bodyFont: {
          weight: 'bold',
          size: 15,
          radius: 20,
        },
      },
    },
  };

  return (
    <div className="flex flex-col gap-5 bg-white">
      <DashboardCardWrapper
        title="Job Statistics"
        redirectURL={pageRoutes.manageJob}
      />

      <div className="flex flex-wrap items-center justify-center gap-10 py-[3%]">
        <div className="w-60">
          <Pie data={chartData} options={option} />
        </div>
        <div>
          {allChartData?.map((data) => (
            <div className="flex items-start space-x-2 py-4" key={data.id}>
              <div className={`rounded-full bg-[${data.hex}] mt-3 p-1`}></div>
              <div>
                <div className="text-2xl font-semibold ">{data?.value}</div>
                <div className="text-[#626262]">{data?.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default JobStatistics;
